import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import {Auth} from '@aws-amplify/auth';

const entityKey = 'resetPassword';

const initialState = {
    requestResult: null,
    requestDetails: null,
    confirmResult: null,
    loading: false,
    error: '',
};

// genenrates pending, fulfilled and rejected
export const requestPasswordChange = createAsyncThunk(
    `${entityKey}/request`,
    ({ account, emailAddress }) => {
        Auth.configure({
            userPoolId: account.cognitoUserPoolId,
            userPoolWebClientId: account.appClientId,
        });

        return Auth.forgotPassword(emailAddress).then((response) => response);
    }
);

export const confirmPasswordChange = createAsyncThunk(
    `${entityKey}/confirm`,
    ({ account, values }) => {
        Auth.configure({
            userPoolId: account.cognitoUserPoolId,
            userPoolWebClientId: account.appClientId,
        });

        return Auth.forgotPasswordSubmit(
            account.username,
            values.otc,
            values.new_password
        ).then((response) => response);
    }
);

const resetPasswordsSlice = createSlice({
    name: entityKey,
    initialState,
    extraReducers: (builder) => {
        // PASSWORD RESET
        builder.addCase(requestPasswordChange.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(requestPasswordChange.fulfilled, (state, action) => {
            const { payload } = action;
            state.requestDetails = payload.CodeDeliveryDetails;
            state.requestResult = 'success';
            state.loading = false;
        });

        builder.addCase(requestPasswordChange.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });

        // CHANGE CONFIRM
        builder.addCase(confirmPasswordChange.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(confirmPasswordChange.fulfilled, (state, action) => {
            const { payload } = action;
            state.confirmResult = 'success';
            state.loading = false;
        });

        builder.addCase(confirmPasswordChange.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export default resetPasswordsSlice.reducer;
